"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WX_APP_CONFIG = void 0;
const WX_APP_CONFIG = exports.WX_APP_CONFIG = {
  corpid: process.env.VUE_APP_WX_CORPID,
  agentid: process.env.VUE_APP_WX_AGENTID,
  state: 'WX_LOGIN_STATE',
  scope: 'snsapi_privateinfo'
};